"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../../button");

var _icons = require("../../../icons");

var _layout = require("../../../layout");

var _screenReaderOnly = require("../../../screen-reader-only");

var _utils = require("../../../utils");

var _InputSegment = _interopRequireDefault(require("./InputSegment"));

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DateTimeSegmentElement = function DateTimeSegmentElement(_ref) {
  var id = _ref.id,
      name = _ref.name,
      min = _ref.min,
      max = _ref.max,
      value = _ref.value,
      onChange = _ref.onChange,
      isReadOnly = _ref.isReadOnly,
      disabled = _ref.disabled,
      placeholder = _ref.placeholder,
      shouldFocus = _ref.shouldFocus,
      onFocus = _ref.onFocus,
      focusPreviousSegment = _ref.focusPreviousSegment,
      focusNextSegment = _ref.focusNextSegment,
      showSpinButtons = _ref.showSpinButtons,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      ariaDescribedBy = _ref.ariaDescribedBy,
      ariaRequired = _ref.ariaRequired,
      ariaInvalid = _ref.ariaInvalid,
      increaseAriaLabel = _ref.increaseAriaLabel,
      decreaseAriaLabel = _ref.decreaseAriaLabel;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      displayValue = _useState2[0],
      setDisplayValue = _useState2[1];

  var _useState3 = (0, _react.useState)(undefined),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      stateValue = _useState4[0],
      setStateValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showAnnounce = _useState6[0],
      setShowAnnounce = _useState6[1];

  var fieldRef = (0, _react.useRef)(null);
  var paddedLength;

  if (name === _interfaces.DateTimeSegment.Year) {
    paddedLength = 4;
  } else if (name === _interfaces.DateTimeSegment.Milliseconds) {
    paddedLength = 3;
  } else {
    paddedLength = 2;
  }

  (0, _react.useEffect)(function () {
    if (value !== undefined && stateValue !== undefined && value !== stateValue) {
      setStateValue(value);
    }
  }, [value, stateValue]);
  (0, _react.useEffect)(function () {
    var numericalValue;

    if (stateValue !== undefined) {
      numericalValue = stateValue;
    } else {
      numericalValue = value;
    }

    if (numericalValue === undefined) {
      setDisplayValue('');
    } else {
      setDisplayValue(numericalValue.toString().padStart(paddedLength, '0'));
    }
  }, [value, stateValue, paddedLength]);
  (0, _react.useEffect)(function () {
    if (fieldRef.current && shouldFocus) {
      fieldRef.current.focus();
    }
  }, [shouldFocus]);

  var handleStepChange = function handleStepChange(stepAmount) {
    var newValue;

    if (value === undefined) {
      // Default year field to current year
      if (name === _interfaces.DateTimeSegment.Year) {
        newValue = new Date().getUTCFullYear();
      } else if (stepAmount > 0) {
        newValue = min;
      } else {
        newValue = max;
      }
    } else {
      newValue = value + stepAmount;

      if (newValue < min) {
        newValue = max;
      } else if (newValue > max) {
        newValue = min;
      }
    }

    setStateValue(newValue);
    onChange(newValue, name);
  };

  var handleStepIncrease = function handleStepIncrease() {
    handleStepChange(1);
    setShowAnnounce(true);
  };

  var handleStepDecrease = function handleStepDecrease() {
    handleStepChange(-1);
    setShowAnnounce(true);
  };

  var handleStopAnnounce = function handleStopAnnounce() {
    setShowAnnounce(false);
  };

  var handleDigit = function handleDigit(digit) {
    var newStateValue;

    if (stateValue === undefined) {
      newStateValue = digit;
    } else {
      newStateValue = 10 * stateValue + digit;

      if (newStateValue > max) {
        newStateValue = digit;
      }
    }

    setStateValue(newStateValue);
    var isValid = newStateValue >= min && newStateValue <= max;

    if (isValid) {
      onChange(newStateValue, name);
    } else {
      onChange(undefined, name);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    var typedDigit = parseInt(e.key);
    var preventDefault = true;

    if (!isNaN(typedDigit)) {
      handleDigit(typedDigit);
    } else {
      switch (e.key) {
        case _utils.EventKeys.BACKSPACE:
        case _utils.EventKeys.DELETE:
          setStateValue(undefined);
          onChange(undefined, name);
          break;

        case _utils.EventKeys.ARROW_UP:
        case _utils.EventKeys.ARROW_DOWN:
          setStateValue(undefined);
          handleStepChange(e.key === _utils.EventKeys.ARROW_UP ? 1 : -1);
          break;

        case _utils.EventKeys.ARROW_LEFT:
          focusPreviousSegment();
          break;

        case _utils.EventKeys.ARROW_RIGHT:
          focusNextSegment();
          break;

        case _utils.EventKeys.PAGE_UP:
        case _utils.EventKeys.PAGE_DOWN:
          setStateValue(undefined);
          handleStepChange(e.key === _utils.EventKeys.PAGE_UP ? 5 : -5);
          break;

        case _utils.EventKeys.HOME:
        case _utils.EventKeys.END:
          setStateValue(undefined);
          onChange(e.key === _utils.EventKeys.HOME ? min : max, name);
          break;

        case _utils.EventKeys.TAB:
          preventDefault = false;
          break;

        default:
          break;
      }
    }

    if (preventDefault) {
      e.preventDefault();
    }
  };

  var handleMouseDown = function handleMouseDown(e) {
    e.preventDefault();

    if (fieldRef.current) {
      fieldRef.current.focus();
    }
  };

  var handleFocus = function handleFocus() {
    setStateValue(undefined);
    onFocus(name);
  };

  var handleBlur = function handleBlur() {
    if (stateValue !== undefined && stateValue !== value) {
      if (stateValue < min) {
        onChange(min, name);
      } else if (stateValue > max) {
        onChange(max, name);
      } else {
        onChange(stateValue, name);
      }
    }

    setStateValue(undefined);
  }; // Note: input type="number" displays poorly in Firefox due to lack of leading zeroes.


  return (0, _core.jsx)(_layout.Col, {
    gridGap: "S100",
    alignItems: "center"
  }, showAnnounce && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
    "aria-live": "polite",
    role: "status"
  }, displayValue, " ", ariaLabel), showSpinButtons && (0, _core.jsx)(_button.Button, {
    "aria-label": increaseAriaLabel,
    icon: (0, _core.jsx)(_icons.IconChevronUp, {
      size: _icons.IconSize.ExtraSmall,
      "aria-hidden": true
    }),
    onBlur: handleStopAnnounce,
    onClick: handleStepIncrease,
    tabIndex: -1,
    variant: _button.ButtonVariant.Tertiary
  }), (0, _core.jsx)(_InputSegment.default, {
    id: id,
    role: "spinbutton",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy,
    "aria-required": ariaRequired,
    "aria-invalid": ariaInvalid,
    "aria-valuenow": value,
    "aria-valuemin": min,
    "aria-valuemax": max,
    value: displayValue,
    readOnly: isReadOnly,
    disabled: disabled,
    width: _constants.segmentInfo[name].width,
    type: "text",
    placeholder: placeholder,
    inputMode: "numeric",
    autoComplete: "off",
    spellCheck: false,
    ref: fieldRef,
    onChange: function onChange() {
      return null;
    },
    onKeyDown: handleKeyDown,
    onMouseDown: handleMouseDown,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), showSpinButtons && (0, _core.jsx)(_button.Button, {
    "aria-label": decreaseAriaLabel,
    icon: (0, _core.jsx)(_icons.IconChevronDown, {
      size: _icons.IconSize.ExtraSmall,
      "aria-hidden": true
    }),
    onBlur: handleStopAnnounce,
    onClick: handleStepDecrease,
    tabIndex: -1,
    variant: _button.ButtonVariant.Tertiary
  }));
};

var _default = DateTimeSegmentElement;
exports.default = _default;